import PaneHeader from '@/components/common/PaneHeader.vue';
import BaseCard from '@/components/common/BaseCard.vue';
import BasePanel from '@/components/common/BasePanel.vue';
import Badge from '@/components/elements/Badge.vue';
import CButton from '@/components/common/CButton.vue';
import ButtonGroup from '@/components/common/ButtonGroup.vue';
import Toggle from '@/components/common/Toggle.vue';
import ToggleBoolean from '@/components/common/ToggleBoolean.vue';
import Icon from '@/components/common/Icon.vue';
import Callout from '@/components/elements/Callout.vue';
import HelpLink from '@/components/elements/HelpLink.vue';
import LoadingDots from '@/components/elements/LoadingDots.vue';
import Modal from '@/components/common/Modal.vue';
import GenericTable from '@/components/common/GenericTable.vue';
import { type App } from 'vue';
import { h, defineComponent } from 'vue';

const FormulateForm = defineComponent(() => () => h('div', ''));
const FormulateInput = defineComponent(() => () => h('div', ''));
const FormulateErrors = defineComponent(() => () => h('div', ''));

interface CutrComponents {
  Modal: typeof Modal;
  CButton: typeof CButton;
  ButtonGroup: typeof ButtonGroup;
  Toggle: typeof Toggle;
  ToggleBoolean: typeof ToggleBoolean;
  Icon: typeof Icon;
  Callout: typeof Callout;
  HelpLink: typeof HelpLink;
  LoadingDots: typeof LoadingDots;
  PaneHeader: typeof PaneHeader;
  Badge: typeof Badge;
  BaseCard: typeof BaseCard;
  BasePanel: typeof BasePanel;
  GenericTable: typeof GenericTable;
  FormulateForm: typeof FormulateForm;
  FormulateInput: typeof FormulateInput;
  FormulateErrors: typeof FormulateErrors;
}

const globalComponents: CutrComponents = {
  Modal,
  CButton,
  ButtonGroup,
  Toggle,
  ToggleBoolean,
  Icon,
  Callout,
  HelpLink,
  LoadingDots,
  PaneHeader,
  Badge,
  BaseCard,
  BasePanel,
  GenericTable,
  FormulateForm,
  FormulateInput,
  FormulateErrors,
};

export function registerGlobalComponents(app: App) {
  Object.entries(globalComponents).forEach(([name, component]) =>
    app.component(name, component)
  );
}

declare module '@vue/runtime-core' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface GlobalComponents extends CutrComponents {}
}
